export type PrintableCategory = "activity" | "coloring";

export interface Printable {
  slug: string;
  category: PrintableCategory;
  titleKey: string;
  descriptionKey: string;
  pdf: string;
  cover: string;
  pages: number;
  publishedAt: string;
}

export const PRINTABLES: Printable[] = [
  {
    slug: "casper-fruit-stand",
    category: "activity",
    titleKey: "activities.printables.items.casperFruitStand.title",
    descriptionKey: "activities.printables.items.casperFruitStand.description",
    pdf: "/downloads/activities/casper-fruit-stand.pdf",
    cover: "/images/activities/casper-fruit-stand.jpg",
    pages: 8,
    publishedAt: "2025-04-01",
  },
  {
    slug: "crabs-and-ponds-counting",
    category: "activity",
    titleKey: "activities.printables.items.crabsPonds.title",
    descriptionKey: "activities.printables.items.crabsPonds.description",
    pdf: "/downloads/activities/crabs-and-ponds-counting.pdf",
    cover: "/images/activities/crabs-and-ponds-counting.jpg",
    pages: 3,
    publishedAt: "2025-04-02",
  },
  {
    slug: "feeding-noodles",
    category: "activity",
    titleKey: "activities.printables.items.feedingNoodles.title",
    descriptionKey: "activities.printables.items.feedingNoodles.description",
    pdf: "/downloads/activities/feeding-noodles.pdf",
    cover: "/images/activities/feeding-noodles.jpg",
    pages: 6,
    publishedAt: "2025-04-03",
  },
  {
    slug: "flash-face-challenge",
    category: "activity",
    titleKey: "activities.printables.items.flashFace.title",
    descriptionKey: "activities.printables.items.flashFace.description",
    pdf: "/downloads/activities/flash-face-challenge.pdf",
    cover: "/images/activities/flash-face-challenge.jpg",
    pages: 6,
    publishedAt: "2025-04-04",
  },
  {
    slug: "earthworm-and-fabio",
    category: "activity",
    titleKey: "activities.printables.items.earthwormFabio.title",
    descriptionKey: "activities.printables.items.earthwormFabio.description",
    pdf: "/downloads/activities/earthworm-and-fabio.pdf",
    cover: "/images/activities/earthworm-and-fabio.jpg",
    pages: 5,
    publishedAt: "2025-04-05",
  },
  {
    slug: "coloring-1",
    category: "coloring",
    titleKey: "activities.printables.items.coloring1.title",
    descriptionKey: "activities.printables.items.coloring1.description",
    pdf: "/downloads/coloring/coloring-1.pdf",
    cover: "/images/coloring/coloring-1.jpg",
    pages: 1,
    publishedAt: "2025-05-01",
  },
  {
    slug: "coloring-2",
    category: "coloring",
    titleKey: "activities.printables.items.coloring2.title",
    descriptionKey: "activities.printables.items.coloring2.description",
    pdf: "/downloads/coloring/coloring-2.pdf",
    cover: "/images/coloring/coloring-2.jpg",
    pages: 1,
    publishedAt: "2025-05-02",
  },
  {
    slug: "coloring-3",
    category: "coloring",
    titleKey: "activities.printables.items.coloring3.title",
    descriptionKey: "activities.printables.items.coloring3.description",
    pdf: "/downloads/coloring/coloring-3.pdf",
    cover: "/images/coloring/coloring-3.jpg",
    pages: 1,
    publishedAt: "2025-05-03",
  },
  {
    slug: "coloring-4",
    category: "coloring",
    titleKey: "activities.printables.items.coloring4.title",
    descriptionKey: "activities.printables.items.coloring4.description",
    pdf: "/downloads/coloring/coloring-4.pdf",
    cover: "/images/coloring/coloring-4.jpg",
    pages: 1,
    publishedAt: "2025-05-04",
  },
  {
    slug: "coloring-5",
    category: "coloring",
    titleKey: "activities.printables.items.coloring5.title",
    descriptionKey: "activities.printables.items.coloring5.description",
    pdf: "/downloads/coloring/coloring-5.pdf",
    cover: "/images/coloring/coloring-5.jpg",
    pages: 1,
    publishedAt: "2025-05-05",
  },
];

export const printablesByCategory = (category: PrintableCategory) =>
  PRINTABLES.filter((p) => p.category === category);
